module.exports = __webpack_public_path__ + "src/assets/img/handler-bg.27a5e045.png";